import React, { useState } from 'react';
import { UserInfo } from '@/components/custom/user';
import { Avatar, AvatarFallback, AvatarStack, AvatarWrapper } from '@/components/ui/avatar';
import { Sheet, SheetBody, SheetCardWrapper, SheetContent, SheetFooter, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { Card, CardContent } from '@/components/ui/card';

export function CardAvatarStack({ data, className, modalTitle, truncateIn, size = 'sm', ...props }) {
  const [showModal, setShowModal] = useState(false);

  const avatarsToShow = data?.slice(0, truncateIn || 3);
  const avatarsHidden = data?.length - (truncateIn || 3);
  const hasMore = avatarsHidden > 0;

  return (
    <>
      <AvatarStack
        size={size}
        onClick={() => setShowModal(true)}
        {...props}
      >
        {avatarsToShow.map(avatar => (
          <AvatarWrapper
            key={avatar?.id}
            size={size}
            isHoverable
            src={avatar?.image?.url}
            text={avatar?.name}
            className="cursor-pointer"
          />
        ))}
        {hasMore && (
          <Avatar
            size={size}
            isHoverable
            title={data?.slice(truncateIn || 3).map(avatar => ` ${avatar?.name}`)}
          >
            <AvatarFallback className="cursor-pointer font-bold text-primary">+{avatarsHidden}</AvatarFallback>
          </Avatar>
        )}
      </AvatarStack>

      <Sheet
        open={showModal}
        onOpenChange={setShowModal}
      >
        <SheetContent>
          <SheetHeader>
            <SheetTitle>{modalTitle && modalTitle}</SheetTitle>
          </SheetHeader>
          <SheetBody>
            <SheetCardWrapper>
              {data?.map(user => (
                <Card
                  key={user?.id}
                  isHover
                >
                  <CardContent>
                    <UserInfo user={user} />
                  </CardContent>
                </Card>
              ))}
            </SheetCardWrapper>
          </SheetBody>
          <SheetFooter />
        </SheetContent>
      </Sheet>
    </>
  );
}
